var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "basicSetting" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "setting-container mt14" },
          [
            _c(
              "el-row",
              [
                _c("el-col", _vm._b({}, "el-col", _vm.grid1, false), [
                  _vm._v(" "),
                ]),
                _vm._v(" "),
                _c(
                  "el-col",
                  _vm._b({}, "el-col", _vm.grid2, false),
                  [
                    _c(
                      "el-form",
                      {
                        ref: "elForm",
                        attrs: {
                          model: _vm.examineFrom,
                          rules: _vm.rules,
                          size: "medium",
                          "label-width": "150px",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("business.businessType1"),
                              prop: "name",
                            },
                          },
                          [
                            _c("el-input", {
                              style: { width: "100%" },
                              attrs: {
                                maxlength: 16,
                                "show-word-limit": "",
                                placeholder: _vm.$t("business.message1"),
                                clearable: "",
                              },
                              model: {
                                value: _vm.examineFrom.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.examineFrom, "name", $$v)
                                },
                                expression: "examineFrom.name",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("business.businessPic1"),
                              prop: "icon",
                            },
                          },
                          [
                            _vm.examineFrom.icon
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "selIcon mr15",
                                    style: {
                                      backgroundColor: _vm.examineFrom.color,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleIcon($event)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon iconfont",
                                      class: _vm.examineFrom.icon,
                                      staticStyle: { color: "#fff" },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-popover",
                              {
                                ref: "iconPopover",
                                attrs: {
                                  placement: "bottom",
                                  width: "400",
                                  trigger: "click",
                                },
                              },
                              [
                                _vm._l(_vm.iconList, function (i, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "icon-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.itemChose(i)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon iconfont",
                                        class: i.icon,
                                        style: { color: i.color },
                                      }),
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("business.changeIcon"))
                                    ),
                                  ]
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("business.businessTypeIn"),
                              prop: "flowRemark",
                            },
                          },
                          [
                            _c("el-input", {
                              style: { width: "100%" },
                              attrs: {
                                type: "textarea",
                                placeholder: _vm.$t("business.message3"),
                                maxlength: 100,
                                "show-word-limit": "",
                                autosize: { minRows: 4, maxRows: 4 },
                              },
                              model: {
                                value: _vm.examineFrom.info,
                                callback: function ($$v) {
                                  _vm.$set(_vm.examineFrom, "info", $$v)
                                },
                                expression: "examineFrom.info",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-col", _vm._b({}, "el-col", _vm.grid1, false)),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }